import React from "react";
import { useApp } from "../state/AppContext";
import { Sparkles, ArrowLeft } from "lucide-react";
import { localizedChallenges, DIFFICULTY_STYLES, localizedDifficulty } from "../data/localize";

export default function GalleryScreen() {
  const { setScreen, setDetailChallenge, user, t, lang } = useApp();
  const challenges = localizedChallenges(lang);

  const openDetail = (c) => { setDetailChallenge(c); setScreen("detail"); };
  const name = user?.first_name?.split(" ")[0] || "friend";

  return (
    <div className="min-h-screen bg-scl-cream pt-6 pb-32" data-testid="gallery-screen">
      <div className="px-6 mb-5">
        <button onClick={() => setScreen("home")} className="flex items-center gap-1 text-sm text-scl-charcoal/70 mb-3 hover:text-scl-teal min-h-[44px]" data-testid="back-to-home">
          <ArrowLeft className="w-4 h-4" /> {t("back")}
        </button>
        <div className="flex items-center gap-2 mb-2">
          <Sparkles className="w-4 h-4 text-scl-coral" />
          <span className="text-xs uppercase tracking-[0.18em] text-scl-coral font-semibold">{t("gallery_kicker")}</span>
        </div>
        <h2 className="font-serif text-3xl sm:text-4xl text-scl-charcoal font-bold leading-tight">
          {t("gallery_title", { name })}
        </h2>
        <p className="text-scl-charcoal/70 mt-1 text-[15px]">{t("gallery_lead")}</p>
      </div>

      <div className="px-4 grid grid-cols-2 gap-3" data-testid="gallery-grid">
        {challenges.map((c) => {
          const d = DIFFICULTY_STYLES[c.difficulty];
          return (
            <button
              key={c.id}
              onClick={() => openDetail(c)}
              data-testid={`challenge-card-${c.id}`}
              className="group relative rounded-2xl overflow-hidden shadow-warm-sm bg-white text-left aspect-[3/4] focus:outline-none focus-visible:ring-2 focus-visible:ring-scl-teal transition-transform active:scale-[0.98] min-h-[44px]"
            >
              <img src={c.image} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-scl-charcoal via-scl-charcoal/40 to-transparent" />
              <div className="absolute top-2 left-2 flex items-center gap-1.5">
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${d.bg} ${d.text}`}>
                  {localizedDifficulty(c.difficulty, lang)}
                </span>
              </div>
              <div className="absolute top-2 right-2">
                <span className="px-2 py-0.5 rounded-full bg-white/95 text-scl-charcoal text-[10px] font-bold">{c.points} pts</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <div className="text-[10px] uppercase tracking-widest text-white/80 font-semibold mb-1">{c.age_display || c.age}</div>
                <div className="font-serif text-white font-bold text-[15px] leading-tight line-clamp-3">{c.title}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
